import React, { ReactNode } from 'react';
import { AppBackgroundLogin } from '../features/background/AppBackground';
import { Box } from '@mui/material';

type LAppFullscreenBackgroundProps = {
	children: ReactNode;
};
const LAppFullscreenBackground = (props: LAppFullscreenBackgroundProps) => {
	return (
		<Box
			style={{
				backgroundColor: '#061841',
				backgroundImage: `url(${AppBackgroundLogin})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center center',
				width: '100%',
				minHeight: '100vh',
				padding: '0px',
			}}
		>
			{props.children}
		</Box>
	);
};

export default LAppFullscreenBackground;
